import saveOAuthCodeLogic from "./saveOAuthCodeLogic";
import refreshOAuthCodeLogic from "./refreshOAuthCodeLogic";

export default [...saveOAuthCodeLogic, ...refreshOAuthCodeLogic];
